// Client-side mirror of the connect-redirect-origins route's input rules (gateway/api/
// connect.py: exact https origins, at most 20). The server re-validates everything.

export const MAX_REDIRECT_ORIGINS = 20

/** The normalized origin for an exact https origin, or an error message. */
export function parseOrigin(value: string): { origin: string } | { error: string } {
  const v = value.trim()
  let url: URL
  try {
    url = new URL(v)
  } catch {
    return { error: 'Enter a full origin like https://app.example.com.' }
  }
  if (url.protocol !== 'https:') return { error: 'Origins must use https.' }
  if (url.username || url.password) return { error: 'An origin can’t contain a user name or password.' }
  if ((url.pathname && url.pathname !== '/') || url.search || url.hash || /[?#]/.test(v)) {
    return { error: 'Enter only the origin (scheme and host, optional port): no path, query or fragment.' }
  }
  return { origin: url.origin }
}
